module.exports={
    header: {
        icon:{
            icon:'/static/images/store_04.png',
            // store:'/static/images/store_06.png',
            // system:'/static/images/store_08.png',
            // template:'/static/images/store_10.png'
        },
        store:'STORE',
        system:'SYSTEM',
        template:'TEMPLATE',
        personInfo:'Profile',
        systemMsg:'Version',
        quit:'Log out',
        switch:'Chinese/English/Japanese',
        dialogTitle:'Version',
        dialog:{
            sure:'OK',
            cancel:'Cancel'
        },
        hintMsg:{
            queryFail:'Failed to query user information!',
            frontendVersion:'Frontend version：{version}',
            backendVersion:'Backend version：{version}'
        },
        quitMsg: 'Are you sure you want to log out?'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/Header.js